module.exports = __webpack_public_path__ + "img/logo_insta_color.24187792.svg";